<script setup>
const props = defineProps({
    dayInfo: {
        type: Object,
        required: true,
        default: () => ({
            current: null,
            isWorkDay: true,
            leaves: [],
            punches: []
        })
    },
})
import { useToast } from "vue-toastification";

const emit = defineEmits(['reFreshCalendar', 'pickDay'])
const toast = useToast()
async function removePunchById(id){
    await axios.delete(`/api/punches/${id}`)
    toast.success('remove punch successfully')
    emit('reFreshCalendar')
    emit('pickDay', props.dayInfo.current)
}

function format(format, dt) {
    switch (format) {
        case 'dt':
            return dayjs(dt).format('YY-MM-DD')
        case 'time':
            return dayjs(dt).format('hh:mm A')
    }
}
</script>

<template>
    <div class="flex mt-2">
        <div v-show="dayInfo.current" class="border border-gray-400 px-1 w-full rounded ">
            <div class="grid grid-cols-2 px-1">
                <div>{{ dayInfo.isWorkDay ? 'Work Day' : 'Holiday' }}</div>
                <div class="ml-1 text-right" >{{format('dt', dayInfo.current) }}</div>
            </div>
            <template v-for="punch in dayInfo.punches">
                <div class="flex px-1  my-1 justify-between h-8 items-center bg-red-400 rounded text-white">
                    <div class="pl-2 grid grid-cols-2">
                        <div>{{ punch.duty === 'on' ? 'Punch on' : 'Punch off' }}</div>
                        <div class="ml-2" >{{ format('time',punch.punch_time) }}</div>
                    </div>
                    <div>
                        <button
                            v-if="!punch.is_locked"
                            class=" hover:text-gray-700  py-1"
                            @click="removePunchById(punch.id)"
                        ><div class="p-1">
                            <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M19 24h-14c-1.104 0-2-.896-2-2v-16h18v16c0 1.104-.896 2-2 2zm-7-10.414l3.293-3.293 1.414 1.414-3.293 3.293 3.293 3.293-1.414 1.414-3.293-3.293-3.293 3.293-1.414-1.414 3.293-3.293-3.293-3.293 1.414-1.414 3.293 3.293zm10-8.586h-20v-2h6v-1.5c0-.827.673-1.5 1.5-1.5h5c.825 0 1.5.671 1.5 1.5v1.5h6v2zm-8-3h-4v1h4v-1z"/></svg>
                        </div>
                        </button>
                    </div>
                </div>
            </template>
            <template v-for="leave in dayInfo.leaves">
                <div class="flex flex-col justify-between px-2 border-t-2 border-green-400">
                    <div class="grid grid-cols-2">
                        <div>leave type:</div>
                        <div class="ml-2">{{leave.leave_type }}</div>
                    </div>
                    <div class="grid grid-cols-2">
                        <div>start time</div>
                        <div class="ml-2">{{ format('time',leave.begin_time) }}</div>
                    </div>
                    <div class="grid grid-cols-2">
                        <div>end time</div>
                        <div class="ml-2" >{{ format('time',leave.end_time) }}</div>
                    </div>
                    <div class="grid grid-cols-2">
                        <div>unit:</div>
                        <div class="ml-2">{{ leave.leave_hours }} <span class="text-sm">(hours)</span></div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
